<template>
  <div v-if="landingPageFlashDeals && landingPageFlashDeals.products && landingPageFlashDeals.products.length">
    <v-container>
      <v-card color="rounded-1r primary green-to-right text-center pa-4 yellow">
        <v-card-title :class="!$vuetify.breakpoint.lgAndUp && 'pa-0 pb-4'">
          <h2 class="mr-3 text-h5 white--text font-weight-bold">{{ $t('label.flashDeals') }}</h2>
          <FlashDealLogo class="flash-logo my-auto" />
          <div class="countdown" :class="!$vuetify.breakpoint.sm && 'ml-3'">
            <Timer :deadline="flashDealEndDate" />
          </div>
        </v-card-title>
        <v-container class="px-4 pt-0 background my-4 rounded-lg">
          <v-row>
            <!-- cols="2" -->
            <v-col v-for="product in landingPageFlashDeals.products" :key="product.id" :xs="6" :sm="3" :md="3" :lg="2" :xl="2" :cols="6">
              <item :productInfo="product" hideRatings whiteBg></item>
            </v-col>
          </v-row>
        </v-container>
        <app-button :label="$t('button.shopMore')" class="mb-4 px-12 mx-auto" :to="{ name: $constants.ROUTE_NAME.PRODUCT_FLASH_DEALS }" />
      </v-card>
    </v-container>
    <Spacer />
  </div>
</template>

<script>
import FlashDealLogo from '@/assets/icons/flash.svg'
import { mapGetters, mapState } from 'vuex'
import Spacer from '@/components/Spacer.vue'
import Timer from '@/components/Timer.vue'
import Item from '@/components/product/Item.vue'

export default {
  components: { FlashDealLogo, Spacer, Item, Timer },

  data() {
    return {}
  },

  computed: {
    ...mapGetters('page', ['landingPageFlashDeals']),
    flashDealEndDate() {
      var dt = new Date()
      dt.setHours(dt.getHours() + this.landingPageFlashDeals.remaining_hour)
      dt.setMinutes(dt.getHours() + this.landingPageFlashDeals.remaining_minute)
      dt.setSeconds(dt.getHours() + this.landingPageFlashDeals.remaining_second)
      return dt
    }
  },

  mounted() {
    // const getItemLimit = () => {
    //   if (this.$vuetify.breakpoint.mdAndUp) {
    //     return 6
    //   }
    //   if (this.$vuetify.breakpoint.sm) {
    //     return 4
    //   }
    //   return 3
    // }
  }
}
</script>

<style lang="scss" scoped>
.gradient-container {
  // background-image: linear-gradient(90deg, red, yellow);
  background-image: linear-gradient(90deg, rgba(0, 194, 1, 0.8), rgba(12, 154, 82, 0.8));
}
.flash-logo {
  max-height: 1.5rem;
}

.flash-deals-drawer {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
}
</style>
